import { FormattedMessage } from 'react-intl';
import { GroupedCashFlows } from '@algoan/dashboard/model';
import { useSelector } from '@algoan/dashboard/store/store';
import { CashFlowsTableStyle } from './style';
import { FormattedMoney } from '../atomic-components';
import {
  getRemainderToLiveForSpecificMonthOrLastCompleteMonth,
  getRemainderToLiveTotal,
} from '@algoan/dashboard/calculators';
import { checkedCashFlowsSelector } from '@algoan/dashboard/store/selectors';

export const RemainderToLiveRow: React.FC<{ groupedCashFlows: GroupedCashFlows }> = ({ groupedCashFlows }) => {
  const checkedRows = useSelector(checkedCashFlowsSelector);

  return (
    <CashFlowsTableStyle.BodyHeader>
      <th>
        <FormattedMessage
          id="widgets.regular_cash_flows_analysis.category.remainder_to_live"
          defaultMessage="Remainder to live"
          description="Row label for remainder to live"
        />
      </th>
      <th />
      {groupedCashFlows.calendar.map((date, index) => {
        return (
          <th key={`category-rg-${index}`}>
            <FormattedMoney
              number={getRemainderToLiveForSpecificMonthOrLastCompleteMonth(groupedCashFlows, checkedRows, date.month)}
            />
          </th>
        );
      })}
      <th>
        <FormattedMoney number={getRemainderToLiveTotal(groupedCashFlows, checkedRows)} />
      </th>
    </CashFlowsTableStyle.BodyHeader>
  );
};
